import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  TextField,
} from "@mui/material";
import { useState } from "react";
import useAPI from "../../../../api/hooks/useAPI";
import useColors from "../../../../api/hooks/useColors";
import { Toast } from "../../../../components/Toast";

const ClearRunningTasksButton = ({}) => {
  const [open, setOpen] = useState(false);
  const [customerIdToClear, setCustomerIdToClear] = useState("");
  const { clearRunningTasks } = useAPI();
  const colors = useColors();

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleSave = () => {
    clearRunningTasks(customerIdToClear)
      .then(() => {
        Toast.success("Running tasks cleared");
      })
      .catch(() => {
        Toast.error("Failed to clear running tasks");
      });
    setOpen(false);
  };

  return (
    <>
      <Button
        variant="outlined"
        sx={{
          backgroundColor: colors.primary_main,
          color: colors.contrast_text_light,
          "&:hover": {
            backgroundColor: colors.primary_dark,
          },
        }}
        onClick={handleClickOpen}
      >
        Clear Running Tasks
      </Button>
      <Dialog
        onKeyUp={(e) => {
          const ENTER = "Enter";

          if (e.key === ENTER) {
            handleSave();
            handleClose();
          }
        }}
        open={open}
        onClose={handleClose}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">Enter Customer ID</DialogTitle>
        <DialogContent>
          <DialogContentText>
            Select the customer ID to delete related running BackgroundTasks.
          </DialogContentText>
          <TextField
            autoFocus
            margin="dense"
            id="name"
            label="Customer ID"
            type="text"
            fullWidth
            onChange={(e) => setCustomerIdToClear(e.target.value)}
          />
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Cancel</Button>
          <Button onClick={handleSave}>Go</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ClearRunningTasksButton;
